
<template>
    <h4>
        <slot/>
    </h4>    
</template>

<style scoped lang="scss">
    h4 {
        margin:0;
        padding:0;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "GridTitle"
});

</script>
